//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import { ReactComponent as InformationCircle } from 'assets/information-circle.svg';
import { t } from 'i18next';

const LoginPasswordRule = ({ iconColor = '' }: { iconColor?: string }) => {
  return (
    <div className="ml-1 tooltip tooltip-right text-left" data-tip={t('login.passwordRule')}>
      <InformationCircle className={`w-4 h-4 ${iconColor}`} />
    </div>
  );
};

export default LoginPasswordRule;
